<template>
  <v-dialog v-model="modelValue" content-class="rounded-lg" max-width="500">
    <v-sheet color="white" class="d-flex flex-column rounded-lg">
      <v-form v-model="form.valid" ref="form" class="d-flex flex-column">
        <div class="d-flex flex-row align-center justify-space-between gap-6 px-6 py-4">
          <span class="font-size-22"> Selecione o modelo de {{ typeTitle }} </span>
          <v-btn icon color="gray" @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-divider />
        <div class="d-flex px-6 py-4">
          <select-printing-template
            v-model="form.fields.selectedTemplate"
            :type="type"
            variant="filled"
            :rules="[$validation.required()]"
          />
        </div>
        <v-divider />
        <div class="d-flex flex-row- align-center justify-end gap-6 px-6 py-4">
          <v-btn class="new-btn" outlined color="primary" @click="close"> Cancelar </v-btn>
          <v-btn
            class="new-btn"
            depressed
            color="primary"
            :disabled="!form.valid"
            :loading="form.loading"
            @click="printPdf"
          >
            Imprimir
          </v-btn>
        </div>
      </v-form>
    </v-sheet>
  </v-dialog>
</template>

<script>
import { Prop, WritableComputed, Computed, Method, AsyncMethod } from '@/_typedefs'
import { PrintingTemplate, PrintingTemplateType } from '@/plugins/api/endpoints/printingTemplate'
import SelectPrintingTemplate from './SelectPrintingTemplate.vue'

export default {
  components: { SelectPrintingTemplate },
  props: {
    /** @type {Prop<boolean>} */
    value: {
      type: Boolean,
      required: true,
    },
    /** @type {Prop<PrintingTemplateType>} */
    type: {
      type: String,
      default: 'report',
    },
    /** @type {Prop<number>} */
    patientId: {
      type: Number,
      required: true,
    },
    /** @type {Prop<string>} */
    text: {
      type: String,
      required: true,
    },
    /** @type {Prop<string?>} */
    extraText: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      form: {
        fields: {
          /** @type {PrintingTemplate?} */
          selectedTemplate: null,
        },
        valid: false,
        loading: false,
      },
    }
  },
  computed: {
    /** @type {WritableComputed<boolean>} */
    modelValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    /** @type {Computed<string>} */
    typeTitle() {
      /** @type {Record<PrintingTemplateType, string>} */
      const titleMap = {
        receipt: 'Receita',
        report: 'Relatório',
      }

      return titleMap[this.type]
    },
  },
  methods: {
    /** @type {Method} */
    close() {
      this.modelValue = false
      const selectedTemplate = this.form.fields.selectedTemplate
      this.form.fields = {
        selectedTemplate: null,
      }
      this.$refs.form.resetValidation()
      this.$emit('closed', selectedTemplate)
    },
    /** @type {AsyncMethod} */
    async printPdf() {
      try {
        this.form.loading = true
        const blob = await this.$api.printingTemplate.print({
          templateId: this.form.fields.selectedTemplate.id,
          patientId: this.patientId,
          text: this.text,
          extraText: this.extraText,
        })
        const typeNameMap = {
          receipt: 'receita',
          report: 'relatório',
        }
        this.$util.downloadBlob(blob, `${typeNameMap[this.type]}.pdf`)
        this.close()
      } catch (error) {
        this.$root.error(error)
      } finally {
        this.form.loading = false
      }
    },
  },
}
</script>

<style></style>
